import { flagStore } from '@rst/libs-ts'

export const { $store: $showAllBlocks, openStore: forceShowAllBlocks } =
	flagStore()
